<template>
  <transition
    name="page-number-transition"
    enter-from-class="page-number-notification__transition--enter-from"
    enter-active-class="page-number-notification__transition--enter-active"
    leave-active-class="page-number-notification__transition--enter-active"
    leave-to-class="page-number-notification__transition--leave-to"
  >
    <div
      v-if="draft && draft.pages && visible"
      class="page-number-notification"
    >
      <NebulaIcon
        symbol-id="studio-slideshow"
        type="ghost"
        size="s"
      />
      <div
        class="page-number-notification__prompt"
      >
        {{ countMessage }}
      </div>
    </div>
  </transition>
</template>

<script>

import {
  NebulaIcon,
} from '@discoveryedu/nebula-components';
import { mapState } from 'pinia';
import {
  useEditorStore,
} from '@/stores';
import movementTracker from '@/mixins/movementTracker';

export default {
  name: 'PageNumberNotification',
  components: {
    NebulaIcon,
  },
  mixins: [movementTracker],
  computed: {
    ...mapState(useEditorStore, [
      'draft',
      'currentPageIndex',
      'draftType',
    ]),
    pageType() {
      return this.draftType === 'board' ? 'Page' : 'Slide';
    },
    countMessage() {
      return this.$t(
        '%(pageType)s %(count)s of %(total)s',
        {
          pageType: this.pageType,
          count: this.currentPageIndex + 1,
          total: this.draft.pages.length,
        },
      );
    },
  },
};
</script>

<style lang="stylus">
  .page-number-notification {
    align-items: center;
    background: white;
    border-radius: $nebula-space-half;
    border: 1px solid black;
    box-shadow: $nebula-shadow-200;
    column-gap: $nebula-space-1x;
    display: flex;
    font-weight: 500;
    padding: $nebula-space-1x;
    width: max-content;

    &__transition--enter-active,
    &__transition--enter-leave {
      transition: all .2s ease;
    }

    &__transition--enter-from, &__transition--leave-to {
      opacity: 0;
    }
  }
</style>
